import { useEvent } from "shared/lib/useEvent"

interface CookiebotOptions {
  timeout?: number
  interval?: number
  onSuccess?: () => void
  onError?: () => void
}

export function useOpenCookieBanner({
  timeout = 30000,
  interval = 200,
  onSuccess,
  onError
}: CookiebotOptions) {
  return useEvent(() => {
    // Try immediately first
    if (window.Cookiebot && typeof window.Cookiebot.renew === "function") {
      window.Cookiebot.renew()
      onSuccess?.()
      return null
    }

    // Otherwise, poll until available
    let attempts = 0
    const maxAttempts = Math.floor(timeout / interval)

    const intervalID = setInterval(() => {
      attempts += 1

      if (window.Cookiebot && typeof window.Cookiebot.renew === "function") {
        clearInterval(intervalID)
        window.Cookiebot.renew()
        onSuccess?.()
      } else if (attempts >= maxAttempts) {
        clearInterval(intervalID)
        onError?.()
      }
    }, interval)

    return () => clearInterval(intervalID)
  })
}
